<template>
  <b-row class="h-100 mt-5">
     <div  class="col-md-6 col-xl-4 mx-auto my-auto text-center">

      <img src="@/assets/img/logo.png" height="80" class="mb-3" />

      <div class="form-side">
        <form-base
          title=""
          action="Send"
          :errors="errors"
          :loading="loading"
          :btn-block="true"
          v-on:handleSubmit="handleSubmit"        
        >
          <template v-slot:header>

            <h3>Forgotten Password</h3>
            <small>Please enter the email address you registered with, and we will email you password reset instructions</small>

          </template>

          <template v-slot:fields>
            <label class="form-group has-float-label mb-4">
              <input
                type="email"
                class="form-control"
                :class="{ 'is-invalid': $v.email.$error }"
                ref="email"
                v-model="email"
              />
              <span>Email</span>
              <div class="invalid-feedback" v-if="!$v.email.required">
                Please enter email address
              </div>
              <div class="invalid-feedback" v-if="!$v.email.email">
                invalid email address
              </div>
            </label>

          </template>

        
        </form-base>

        <div class="mt-3 text-center">
            <router-link  :to="{name:'login'}" class="text-primary">
              Back to Sign In
            </router-link>
        </div>
      

      </div>

      <b-modal ref="error-modal" title="Error">
        Whoops! Something went wrong!
      </b-modal>

      <b-modal ref="success-modal" title="Success">
        Email Sent, please check your email account for password reset instructions
      </b-modal>
    </div>
  </b-row>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import formBase from '@/components/common/FormBase'
import authRepo from '@/api/repos/authRepo'

export default {
  components: {
    formBase
  },
  mounted () {
    this.$refs.email.focus()
  },
  data () {
    return {
      email: '',
      loading: false,
      errors: []
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },

  methods: {

    async handleSubmit () {
      this.loading = true

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.loading = false
      } else {
        try {
          await authRepo.forgotPassword(this.email)
          this.$refs['success-modal'].show()
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors.push('Invalid Credentials')
            this.email = ''
            this.$refs.email.focus()
          } else {
            this.$refs['error-modal'].show()
          }
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
